import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import TopicList from "../topics/TopicList";
import TopicDetail from "../topics/TopicDetail";
import SubtopicDetail from "../subtopics/SubtopicDetail";
import Search from "../search/Search";
import Login from "../auth/Login";
import Register from "../auth/Register";
import Profile from "../profile/Profile";
import EditTopic from "../topics/EditTopic";
import PrivateRoute from "./PrivateRoute";
import SubtopicEdit from "../topics/SubtopicEdit";

const AppRoutes = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={!isAuthenticated ? <Login /> : <Navigate to="/" />}
      />
      <Route
        path="/register"
        element={!isAuthenticated ? <Register /> : <Navigate to="/" />}
      />
      <Route
        path="/profile"
        element={isAuthenticated ? <Profile /> : <Navigate to="/login" />}
      />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <TopicList />
          </PrivateRoute>
        }
      />
      <Route
        path="/topic/:id"
        element={
          <PrivateRoute>
            <TopicDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/topic/:topicId/subtopic/:subtopicId"
        element={
          isAuthenticated ? <SubtopicDetail /> : <Navigate to="/login" />
        }
      />
      <Route
        path="/search"
        element={isAuthenticated ? <Search /> : <Navigate to="/login" />}
      />
      <Route
        path="/topic/:id/edit"
        element={
          <PrivateRoute>
            <EditTopic />
          </PrivateRoute>
        }
      />
      <Route
        path="/topic/:topicId/subtopic/:subtopicId/edit"
        element={
          <PrivateRoute>
            <SubtopicEdit />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
